"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var moment = require("moment");
var BaseController_1 = require("../../../../../../shared/controllers/BaseController");
var UIUtils_1 = require("../../../../../../shared/modules/UIUtils");
var webAApi_1 = require("../../../../../api/webAApi");
var BonusTournamentsTicketsListCtl = /** @class */ (function (_super) {
    __extends(BonusTournamentsTicketsListCtl, _super);
    function BonusTournamentsTicketsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_key = UIUtils_1.UIUtils.IProp2Str(function (o) { o.key; });
        _this.dk_app_currency_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_id; });
        _this.dk_app_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.app_currency_title; });
        _this.dk_price = UIUtils_1.UIUtils.IProp2Str(function (o) { o.price; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added2; });
        _this.dk_date_changed2 = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed2; });
        _this._errDialog = errDialog;
        return _this;
    }
    BonusTournamentsTicketsListCtl.prototype.ResetData = function () {
        this.DATA = {
            data: [],
            total: 0
        };
    };
    BonusTournamentsTicketsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        throw "object with id [" + id + "] not found !";
    };
    BonusTournamentsTicketsListCtl.prototype.LoadData = function (bonusTournamentId, onDone) {
        var _this = this;
        webAApi_1.ListTournamentTicketsByTournamentIdGet.exec({
            bonus_tournament_id: bonusTournamentId
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    app_currency_id: resp.list[i].app_currency_id,
                    app_currency_title: resp.list[i].app_currency_title,
                    price: resp.list[i].price,
                    date_added2: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed2: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    description: resp.list[i].description,
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsTicketsListCtl.prototype.AddData = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddTournamentTicket.exec({
            data: {
                bonus_tournament_id: data.bonus_tournament_id,
                app_currency_id: data.app_currency_id,
                price: data.price,
                description: data.description
            }
        }, function (resp) {
            _this.DATA.data.push({
                key: resp.key_uid,
                app_currency_id: data.app_currency_id,
                price: data.price,
                app_currency_title: resp.app_currency_title,
                date_changed2: moment(resp.date_changed_uts_ms).utc(false),
                date_added2: moment(resp.date_added_uts_ms).utc(false),
                description: data.description
            });
            _this.DATA.total++;
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    BonusTournamentsTicketsListCtl.prototype.EditData = function (data, onDone) {
        var _this = this;
        var _tmp = this.getById(data.key);
        if (_tmp) {
            webAApi_1.DoEditTournamentTicket.exec({
                data: {
                    bonus_tournament_ticket_id: data.key,
                    app_currency_id: data.app_currency_id,
                    price: data.price,
                    description: data.description
                }
            }, function (resp) {
                _tmp.app_currency_id = data.app_currency_id;
                _tmp.app_currency_title = resp.app_currency_title;
                _tmp.date_changed2 = moment(resp.date_changed_uts_ms).utc(false);
                _tmp.description = data.description;
                _tmp.price = data.price;
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    BonusTournamentsTicketsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    BonusTournamentsTicketsListCtl.prototype.DeleteData = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoDeleteTournamentTicket.exec({
                data: {
                    bonus_tournament_ticket_id: key
                }
            }, function (resp) {
                _this.RemoveItem(key);
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    return BonusTournamentsTicketsListCtl;
}(BaseController_1.BaseController));
exports.BonusTournamentsTicketsListCtl = BonusTournamentsTicketsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/gift_tournament/ctl/options/BonusTournamentsTicketsListCtl.ts
// module id = 1017
// module chunks = 0